/* @ngInject */
const wagonCtrl = (
  $scope,
  $$wagon,
  $$train,
  $$railway,
  $$area
) => {
  $scope.$$wagon = $$wagon
  $scope.$$train = $$train
  $scope.$$railway = $$railway
  $scope.$$area = $$area
}

export default wagonCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/wagon/wagon.controller.js